export default "__VITE_ASSET__WlzyOK20__"